import {
  DATE_RANGE_PREFERENCE,
  DASHBOARD_PROGRESSION_DATE_RANGE_PREFERENCE,
  THREAT_PROGRESSION_DATE_RANGE_PREFERENCE,
  PRIVILEGE_ACTIVITIES_DATE_RANGE_PREFERENCE,
  DETECTION_DATE_RANGE_PREFERENCE,
  ACTIVITIES_DATE_RANGE_PREFERENCE,
  INSIGHTS_DATE_RANGE_PREFERENCE,
  HOST_INSIGHTS_DATE_RANGE_PREFERENCE,
  THREAT_HUNTING_DATE_RANGE_PREFERENCE,
  ANOMALIES_DATE_RANGE_PREFERENCE
} from './user-pref.type'
import { DATE_RANGE_CHOICES, INSIGHTS_DATE_RANGE_CHOICES } from '@/constants/datetime.constants'

// prettier-ignore
const state = {  
  globalDateRangeUserSetting:
      localStorage.getItem('global_daterange_preferences') &&
      localStorage.getItem('global_daterange_preferences')
        ? localStorage.getItem('global_daterange_preferences')
        : DATE_RANGE_CHOICES[0].value,
  dashboardProgressionDateRangeUserSetting:
        localStorage.getItem('dashboard_progression_daterange_preferences') &&
        localStorage.getItem('dashboard_progression_daterange_preferences')
          ? localStorage.getItem('dashboard_progression_daterange_preferences')
          : DATE_RANGE_CHOICES[3].value, // default to 1 week
  trailProgressionDateRangeUserSetting:
        localStorage.getItem('trail_progression_daterange_preferences') &&
        localStorage.getItem('trail_progression_daterange_preferences')
          ? localStorage.getItem('trail_progression_daterange_preferences')
          : DATE_RANGE_CHOICES[3].value, // default to 1 week
  privilegedActivitiesDateRangeUserSetting:
          localStorage.getItem('privileged_activities_daterange_preferences') &&
          localStorage.getItem('privileged_activities_daterange_preferences')
            ? localStorage.getItem('privileged_activities_daterange_preferences')
            : DATE_RANGE_CHOICES[3].value, // default to 1 week
  detectionsDateRangeUserSetting:
          localStorage.getItem('detections_daterange_preferences') &&
          localStorage.getItem('detections_daterange_preferences')
            ? localStorage.getItem('detections_daterange_preferences')
            : DATE_RANGE_CHOICES[0].value, // default to 24 hours
  activitiesDateRangeUserSetting:
            localStorage.getItem('activities_daterange_preferences') &&
            localStorage.getItem('activities_daterange_preferences')
              ? localStorage.getItem('activities_daterange_preferences')
              : DATE_RANGE_CHOICES[0].value, // default to 24 hours
  insightsDateRangeUserSetting:
          localStorage.getItem('insights_daterange_preferences') &&
          localStorage.getItem('insights_daterange_preferences')
            ? localStorage.getItem('insights_daterange_preferences')
            : INSIGHTS_DATE_RANGE_CHOICES[3].value, // default to 24 hours
  hostInsightsDateRangeUserSetting:
            localStorage.getItem('host_insights_daterange_preferences') &&
            localStorage.getItem('host_insights_daterange_preferences')
              ? localStorage.getItem('host_insights_daterange_preferences')
              : INSIGHTS_DATE_RANGE_CHOICES[3].value, // default to 24 hours
  threatHuntingDateRangeUserSetting:
              localStorage.getItem('threat_hunting_daterange_preferences') &&
              localStorage.getItem('threat_hunting_daterange_preferences')
                ? localStorage.getItem('threat_hunting_daterange_preferences')
                : INSIGHTS_DATE_RANGE_CHOICES[3].value, // default to 24 hours
  anomaliesDateRangeUserSetting:
                localStorage.getItem('anomalies_daterange_preferences') &&
                localStorage.getItem('anomalies_daterange_preferences')
                  ? localStorage.getItem('anomalies_daterange_preferences')
                  : INSIGHTS_DATE_RANGE_CHOICES[3].value // default to 24 hours
}

const getters = {
  dateRangeUserSetting: state => state.dateRangeUserSetting,
  dashboardProgressionDateRangeUserSetting: state => state.dashboardProgressionDateRangeUserSetting,
  trailProgressionDateRangeUserSetting: state => state.trailProgressionDateRangeUserSetting,
  privilegedActivitiesDateRangeUserSetting: state => state.privilegedActivitiesDateRangeUserSetting,
  detectionsDateRangeUserSetting: state => state.detectionsDateRangeUserSetting,
  activitiesDateRangeUserSetting: state => state.activitiesDateRangeUserSetting,
  insightsDateRangeUserSetting: state => state.insightsDateRangeUserSetting,
  hostInsightsDateRangeUserSetting: state => state.hostInsightsDateRangeUserSetting,
  threatHuntingDateRangeUserSetting: state => state.threatHuntingDateRangeUserSetting,
  anomaliesDateRangeUserSetting: state => state.anomaliesDateRangeUserSetting
}

const mutations = {
  [DATE_RANGE_PREFERENCE]: (state, pref) => {
    state.globalDateRangeUserSetting = pref
    localStorage.setItem('global_daterange_preferences', pref)
  },
  [DASHBOARD_PROGRESSION_DATE_RANGE_PREFERENCE]: (state, pref) => {
    state.dashboardProgressionDateRangeUserSetting = pref
    localStorage.setItem('dashboard_progression_daterange_preferences', pref)
  },
  [THREAT_PROGRESSION_DATE_RANGE_PREFERENCE]: (state, pref) => {
    state.trailProgressionDateRangeUserSetting = pref
    localStorage.setItem('trail_progression_daterange_preferences', pref)
  },
  [PRIVILEGE_ACTIVITIES_DATE_RANGE_PREFERENCE]: (state, pref) => {
    state.privilegedActivitiesDateRangeUserSetting = pref
    localStorage.setItem('privileged_activities_daterange_preferences', pref)
  },
  [DETECTION_DATE_RANGE_PREFERENCE]: (state, pref) => {
    state.detectionsDateRangeUserSetting = pref
    localStorage.setItem('detections_daterange_preferences', pref)
  },
  [ACTIVITIES_DATE_RANGE_PREFERENCE]: (state, pref) => {
    state.activitiesDateRangeUserSetting = pref
    localStorage.setItem('activities_daterange_preferences', pref)
  },
  [INSIGHTS_DATE_RANGE_PREFERENCE]: (state, pref) => {
    state.insightsDateRangeUserSetting = pref
    localStorage.setItem('insights_daterange_preferences', pref)
  },
  [HOST_INSIGHTS_DATE_RANGE_PREFERENCE]: (state, pref) => {
    state.hostInsightsDateRangeUserSetting = pref
    localStorage.setItem('host_insights_daterange_preferences', pref)
  },
  [THREAT_HUNTING_DATE_RANGE_PREFERENCE]: (state, pref) => {
    state.threatHuntingDateRangeUserSetting = pref
    localStorage.setItem('threatHuntingDateRangeUserSetting', pref)
  },
  [ANOMALIES_DATE_RANGE_PREFERENCE]: (state, pref) => {
    state.anomaliesDateRangeUserSetting = pref
    localStorage.setItem('anomalies_daterange_preferences', pref)
  }
}

const actions = {
  [DATE_RANGE_PREFERENCE] (context, dateRangePref) {
    context.commit(DATE_RANGE_PREFERENCE, dateRangePref)
  },
  [DASHBOARD_PROGRESSION_DATE_RANGE_PREFERENCE] (context, dateRangePref) {
    context.commit(DASHBOARD_PROGRESSION_DATE_RANGE_PREFERENCE, dateRangePref)
  },
  [THREAT_PROGRESSION_DATE_RANGE_PREFERENCE] (context, dateRangePref) {
    context.commit(THREAT_PROGRESSION_DATE_RANGE_PREFERENCE, dateRangePref)
  },
  [PRIVILEGE_ACTIVITIES_DATE_RANGE_PREFERENCE] (context, dateRangePref) {
    context.commit(PRIVILEGE_ACTIVITIES_DATE_RANGE_PREFERENCE, dateRangePref)
  },
  [DETECTION_DATE_RANGE_PREFERENCE] (context, dateRangePref) {
    context.commit(DETECTION_DATE_RANGE_PREFERENCE, dateRangePref)
  },
  [ACTIVITIES_DATE_RANGE_PREFERENCE] (context, dateRangePref) {
    context.commit(ACTIVITIES_DATE_RANGE_PREFERENCE, dateRangePref)
  },
  [INSIGHTS_DATE_RANGE_PREFERENCE] (context, dateRangePref) {
    context.commit(INSIGHTS_DATE_RANGE_PREFERENCE, dateRangePref)
  },
  [HOST_INSIGHTS_DATE_RANGE_PREFERENCE] (context, dateRangePref) {
    context.commit(HOST_INSIGHTS_DATE_RANGE_PREFERENCE, dateRangePref)
  },
  [THREAT_HUNTING_DATE_RANGE_PREFERENCE] (context, dateRangePref) {
    context.commit(THREAT_HUNTING_DATE_RANGE_PREFERENCE, dateRangePref)
  },
  [ANOMALIES_DATE_RANGE_PREFERENCE] (context, dateRangePref) {
    context.commit(ANOMALIES_DATE_RANGE_PREFERENCE, dateRangePref)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user_pref/daterange-pref.module.js